import { TokenWithValue } from '@/domain/common/types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { SuccessViewPanelTitle } from '@/features/dialogs/common/components/success-view/SuccessPanelTitle'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewPanel } from '@/features/dialogs/common/components/success-view/SuccessViewPanel'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewTokenRow } from '@/features/dialogs/common/components/success-view/SuccessViewTokenRow'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

export interface SuccessViewProps {
  repayAsset: TokenWithValue
  inputAsset: TokenWithValue
  onProceed: () => void
  proceedText: string
  className?: string
  successViewProceedButtonDataTestId?: string
}
export function SuccessView({
  repayAsset,
  inputAsset,
  onProceed,
  proceedText,
  className,
  successViewProceedButtonDataTestId,
}: SuccessViewProps) {
  return (
    <SuccessViewContent className={className}>
      <SuccessViewCheckmark />
      <SuccessViewPanel className="gap-4">
        {inputAsset.token.symbol === TokenSymbol('USDC') && repayAsset.token.symbol === TokenSymbol('USDS') && (
          <div className={cn('flex flex-col md:flex-row md:gap-9')}>
            <div className="flex grow flex-col" data-testid={testIds.dialog.repay.success.swappedFrom}>
              <SuccessViewPanelTitle>Swapped from</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={inputAsset.token} amount={inputAsset.value} />
            </div>
            <div className="flex grow flex-col" data-testid={testIds.dialog.repay.success.swappedTo}>
              <SuccessViewPanelTitle>To</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={repayAsset.token} amount={repayAsset.value} />
            </div>
          </div>
        )}
        <div className="flex flex-col" data-testid={testIds.dialog.repay.success.repaid}>
          <SuccessViewPanelTitle>Repaid</SuccessViewPanelTitle>
          <SuccessViewTokenRow token={repayAsset.token} amount={repayAsset.value} />
        </div>
      </SuccessViewPanel>
      <SuccessViewProceedButton onProceed={onProceed} dataTestId={successViewProceedButtonDataTestId}>
        {proceedText}
      </SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
